import watchTotais from './saga/totais';
import watchGraficoCustoProducaoPorTalhao from './saga/graficoCustoProducaoPorTalhao';
import watchGraficoCustoTipoInsumo from './saga/graficoCustoTipoInsumo';
import watchListCustos from './saga/listCustos';

import watchListCustoProcedimentos from './saga/listCustoProcedimentos';
import watchListCustoDespesaDireta from './saga/listCustoDespesaDireta';
import watchListCustoInsumos from './saga/listCustoInsumos';
import watchListCustoMaquinarios from './saga/listCustoMaquinarios';
import watchListCustoFuncionarios from './saga/listCustoFuncionarios';

export const dashboardSaga = [
    watchTotais(),
    watchGraficoCustoProducaoPorTalhao(),
    watchGraficoCustoTipoInsumo(),
    watchListCustos(),
    watchListCustoProcedimentos(),
    watchListCustoDespesaDireta(),
    watchListCustoInsumos(),
    watchListCustoMaquinarios(),
    watchListCustoFuncionarios(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
